// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TimeEntry styles v2.0.0 */
.timeEntry-control {
	vertical-align: middle;
	margin-left: 2px;
}
`, "",{"version":3,"sources":["webpack://./web_modules/jquery-timeentry/jquery.timeentry.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;CACC,sBAAsB;CACtB,gBAAgB;AACjB","sourcesContent":["/* TimeEntry styles v2.0.0 */\r\n.timeEntry-control {\r\n\tvertical-align: middle;\r\n\tmargin-left: 2px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
